<template>
  <div
    v-if="dataInclusao"
    class="alert alert-secondary"
    role="alert"
    style="margin-bottom: 0;"
  >
    <span>Incluído em {{ dataInclusao }} por {{ usuarioInclusao }}</span>
    <span v-if="dataAlteracao">
      e alterado em {{ dataAlteracao }} por {{ usuarioAlteracao }}
    </span>
  </div>
</template>

<script>
export default {
  name: "DatasInclusaoAlteracao",
  props: [
    "dataInclusao",
    "dataAlteracao",
    "usuarioInclusao",
    "usuarioAlteracao"
  ]
};
</script>

<style lang="scss" scoped></style>
